import {
  GET_ORGANIZATIONS_FAIL,
  GET_ORGANIZATIONS_REQUEST,
  GET_ORGANIZATIONS_SUCCESS,
  GET_ORGANIZATIONS_CANCEL,
  REMOVE_ORGANIZATION,
  UPDATE_ORGANIZATION,
  UPDATE_ORGANIZATIONS,
} from '../actions/organizations';

const initialState = {
  organizations: [],
  organizationsTotal: 0,
  organizationsAllTotal: 0,
  organizationsActiveTotal: 0,
  organizationsBlockedTotal: 0,
  organizationsSearchInfo: null,
  organizationsLoading: false,
  organizationsError: false,
  organizationsErrorMessage: '',
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_ORGANIZATIONS_REQUEST: {
      return {
        ...state,
        organizationsLoading: true,
        organizationsError: false,
        organizationsErrorMessage: '',
      };
    }
    case GET_ORGANIZATIONS_SUCCESS: {
      const {
        organizations, total, total_active: totalActive, total_blocked: totalBlocked, search,
      } = action.payload;
      // Счётчики считаются по уже отфильтрованной выборке, поэтому обновляются при каждом ответе.
      const hasCounters = Number.isFinite(totalActive) && Number.isFinite(totalBlocked);

      return {
        ...state,
        organizations: organizations || [],
        organizationsTotal: total || 0,
        organizationsAllTotal: hasCounters ? totalActive + totalBlocked : state.organizationsAllTotal,
        organizationsActiveTotal: hasCounters ? totalActive : state.organizationsActiveTotal,
        organizationsBlockedTotal: hasCounters ? totalBlocked : state.organizationsBlockedTotal,
        organizationsSearchInfo: search || null,
        organizationsLoading: false,
        organizationsError: false,
        organizationsErrorMessage: '',
      };
    }
    case GET_ORGANIZATIONS_FAIL: {
      return {
        ...state,
        organizationsLoading: false,
        organizationsError: true,
        organizationsErrorMessage: action.payload || 'Не удалось загрузить предложения',
      };
    }
    case GET_ORGANIZATIONS_CANCEL: {
      return {
        ...state,
        organizationsLoading: false,
        organizationsError: false,
      };
    }
    case UPDATE_ORGANIZATION: {
      const newOrganizations = state.organizations.map(
        (item) => (item._id === action.payload._id ? { ...item, ...action.payload } : item),
      );
      return {
        ...state,
        organizationsLoading: false,
        organizationsError: false,
        organizations: newOrganizations,
      };
    }
    case UPDATE_ORGANIZATIONS: {
      const updatesById = (action.payload || []).reduce((acc, o) => ({ ...acc, [o._id]: o }), {});
      const newOrganizations = state.organizations.map((item) => {
        const update = updatesById[item._id];
        return update ? { ...item, ...update } : item;
      });
      return {
        ...state,
        organizations: newOrganizations,
      };
    }
    case REMOVE_ORGANIZATION: {
      const newOrganizations = state.organizations.filter((item) => item._id !== action.payload._id);
      return {
        ...state,
        organizationsLoading: false,
        organizationsError: false,
        organizations: newOrganizations,
      };
    }

    default: {
      return state;
    }
  }
}
